import { RecordCreate, Values } from "@pdfking/tfunc"

import type { Preset } from "#public"

import { DjSelect } from "../forms/fields/DjSelect"
import { useTranslation } from "../i18n/useTranslation"

// Preset names are interpolated translation strings (e.g. "${size}"), so the
// translation context is the preset itself.
export function PresetSelect({
  value,
  on_change,
  presets,
}: {
  value: string
  on_change: (id: string) => void
  presets: Record<string, Preset>
}) {
  const labels = useTranslation("entities")
  const choices = RecordCreate(
    Values(presets).map(p => [p.id, `${p.emoji} ${labels[p.name]?.(p) ?? p.id}`])
  )
  return (
    // No size override: this sits directly above the form's own selects, so it
    // takes `INPUT_CLASS`'s h-8/text-sm like every other field rather than the
    // h-7/text-xs it used to carry, which read as a different control.
    <DjSelect
      choices={choices}
      input={value}
      onselect={(id: string | string[]) => on_change(String(id))}
    />
  )
}
